import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Link from "shared/components/Link";
import isSpa from "shared/util/isSpa";
import { selectedOptionOnNavBarEvent } from "routers/Desktop/NavBar/components/util/analytics";

import { ICON_SIZE } from "routers/Desktop/NavBar/components/util/constants";

import "./NavBarLink.scss";

const NavBarLink = ({ isSelected, IconComponent, text, path, isExternal }) => (
	<Link
		to={path}
		className={classnames("navbar-link", { isSelected })}
		onClick={() => {
			selectedOptionOnNavBarEvent(text);
		}}
		noSpa={!isSpa() || isExternal}
	>
		{IconComponent && (
			<div className="navbar-link-icon-container">
				<IconComponent
					className={classnames("navbar-link-icon", {
						isSelected,
					})}
					width={ICON_SIZE}
					height={ICON_SIZE}
				/>
			</div>
		)}
		<span className="navbar-link-text">
			{text}
		</span>
	</Link>
);

NavBarLink.defaultProps = {
	isSelected: false,
};

NavBarLink.propTypes = {
	isSelected: PropTypes.bool,
	IconComponent: PropTypes.func,
	text: PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
	isExternal: PropTypes.bool,
};

NavBarLink.defaultProps = {
	IconComponent: null,
	isExternal: false,
};

export default NavBarLink;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/NavBarLink.jsx